import $i18n from 'panda-i18n';

const IS_TYPE = [
  {
    label: $i18n.get({ id: 'Yes', dm: '是' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'Yes', dm: '是' }),
    value: 'YES',
  },

  {
    label: $i18n.get({ id: '31255237809541120.CNTM', dm: '否' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: '31255237809541120.CNTM', dm: '否' }),
    value: 'NO',
  },
];

/**
 * @description 操作日志的描述字典
 */
const OPERATION_DESC_TYPE = [
  {
    label: $i18n.get({ id: 'CallForInquiry', dm: '打托 查询' }),
    value: 'PLA0001',
  },

  {
    label: $i18n.get({ id: 'TrayLabelPrintingSubmit', dm: '托盘标签打印-提交' }),
    value: 'PLA0002',
  },

  {
    label: $i18n.get({ id: 'TotoSubmission', dm: '打托-提交' }),
    value: 'PLA0003',
  },

  {
    label: $i18n.get({ id: 'MeasurementQuery', dm: '测量-查询' }),
    value: 'PLA0004',
  },

  {
    label: $i18n.get({ id: 'MeasurementSubmission', dm: '测量-提交' }),
    value: 'PLA0005',
  },

  {
    label: $i18n.get({ id: 'Hitfailed', dm: '打托-失败' }),
    value: 'PLA0006',
  },

  {
    label: $i18n.get({ id: 'MeasurementFailure', dm: '测量-失败' }),
    value: 'PLA0007',
  },

  {
    label: $i18n.get({ id: 'ButoCancel', dm: '打托-取消' }),
    value: 'PLA0008',
  },

  {
    label: $i18n.get({ id: 'TheForcedEndOfTheCall_1334465145', dm: '打托强制完结' }),
    value: 'PLA0009',
  },

  {
    label: $i18n.get({ id: 'TrayShelfQuery', dm: '托盘上架-查询' }),
    value: 'P0001',
  },

  {
    label: $i18n.get({ id: 'TrayShelfSubmit', dm: '托盘上架-提交' }),
    value: 'P0002',
  },

  {
    label: $i18n.get({ id: 'TrayShelvingfailed', dm: '托盘上架-失败' }),
    value: 'P0003',
  },

  {
    label: $i18n.get({ id: 'TrayShelfCancel', dm: '托盘上架-取消' }),
    value: 'P0004',
  },

  {
    label: $i18n.get({ id: 'ForcedEndOfWarehousing', dm: '入库强制完结' }),
    value: 'P0005',
  },

  {
    label: $i18n.get({ id: 'UnloadingInquiry', dm: '卸货查询' }),
    value: 'U0001',
  },

  {
    label: $i18n.get({ id: 'UnloadingSubmission.four_px', dm: '卸货提交' }),
    value: 'U0002',
  },

  {
    label: $i18n.get({ id: 'AbnormalUnloading.four_px', dm: '卸货异常' }),
    value: 'U0003',
  },

  {
    label: $i18n.get({ id: 'CancellationOfUnloading', dm: '卸货取消' }),
    value: 'U0004',
  },

  {
    label: $i18n.get({ id: 'CompulsoryCompletionOfUnloading', dm: '卸货强制完结' }),
    value: 'U0005',
  },

  {
    label: $i18n.get({ id: 'ShippedSubmitted', dm: '已发货-提交' }),
    value: 'S0001',
  },
];

const FBA_ORDER_TYPE = [
  {
    label: $i18n.get({ id: '31255238468046848.CNTM', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'Ordered.four_px', dm: '已下单' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'ArrivedInTheWarehouse', dm: '已到仓' }),
    value: 'U',
  },

  {
    label: $i18n.get({ id: 'AlreadyAttached.four_px', dm: '已打托' }),
    value: 'V',
  },

  {
    label: $i18n.get({ id: 'PartialShelving.four_px', dm: '部分上架' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Stored.four_px', dm: '已入库' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'Departed', dm: '已发车' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'DeliveredWarehouse.four_px', dm: '已送仓' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: 'X',
  },

  {
    label: $i18n.get({ id: 'Terminated.four_px', dm: '已终止' }),
    value: 'T',
  },
];

// 货物入4PX仓方式
const FROM_WAREHOUSE_MODE = [
  {
    label: $i18n.get({ id: '31255238468046848.CNTM', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: '20GPBbulk', dm: '20GP(B 散箱)' }),
    value: 'GP_B_20',
  },

  {
    label: $i18n.get({ id: '20GPPpallt', dm: '20GP(P 托装)' }),
    value: 'GP_P_20',
  },

  {
    label: $i18n.get({ id: '40GPBbulk', dm: '20HQ(B 散箱)' }),
    value: 'HQ_B_20',
  },

  {
    label: $i18n.get({ id: '40GPPpallt', dm: '20HQ(P 托装)' }),
    value: 'HQ_P_20',
  },

  {
    label: $i18n.get({ id: '40HQBbulk', dm: '40HQ(B 散箱)' }),
    value: 'HQ_B_40',
  },

  {
    label: $i18n.get({ id: '40HQPpallt', dm: '40HQ(P 托装)' }),
    value: 'HQ_P_40',
  },

  {
    label: $i18n.get({ id: '45HQBbulk', dm: '40GP(B 散箱)' }),
    value: 'GP_B_40',
  },

  {
    label: $i18n.get({ id: '40GPPpallt', dm: '40GP(P 托装)' }),
    value: 'GP_P_40',
  },

  {
    label: $i18n.get({ id: '45HQBbulk', dm: '45HQ(B 散箱)' }),
    value: 'HQ_B_45',
  },

  {
    label: $i18n.get({ id: '45HQPpallt', dm: '45HQ(P 托装)' }),
    value: 'HQ_P_45',
  },

  {
    label: $i18n.get({ id: 'LCLBBulkBox', dm: 'LCL(B 散箱)' }),
    value: 'LCL_B',
  },

  {
    label: $i18n.get({ id: 'LCLPSupport', dm: 'LCL(P 托装)' }),
    value: 'LCL_P',
  },
];

// FBA送仓方式
const SHIPPING_TYPE = [
  {
    label: $i18n.get({ id: '31255238468046848.CNTM', dm: '全部' }),
    value: 'ALL',
  },

  {
    label: 'FTL',
    value: 'FTL',
  },

  {
    label: 'LTL',
    value: 'LTL',
  },
];

/**
 * 订单类型
 */
const FBA_IN_ORDER_TYPE = [
  {
    label: $i18n.get({ id: 'ZY.Operation.four_px', dm: '作业' }),
    value: 'D',
  },

  {
    label: $i18n.get({ id: 'Walking.four_px', dm: '行走' }),
    value: 'W',
  },
];

/**
 * 备货状态 M-备货缺货|F-备货完成
 */
const FBA_STOCKING_STATE = [
  {
    label: $i18n.get({ id: '31255238468046848.CNTM', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'StockOut', dm: '备货缺货' }),
    value: 'M',
  },

  {
    label: $i18n.get({ id: '31255240762331137.CNTM', dm: '备货完成' }),
    value: 'F',
  },
];

/**
 * 发货单状态 N-待发货|G-发货中|F-已发货
 */
const FBA_DELIVER_TYPE = [
  {
    label: $i18n.get({ id: '31255238468046848.CNTM', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'ToBeShipped', dm: '待发货' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'InDelivery', dm: '发货中' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'Shipped.four_px', dm: '已发货' }),
    value: 'F',
  },
];

/**
 * 运输类型 G-卡车 E-快递
 */
const FBA_TRAQNSPORT_TYPE = [
  {
    label: $i18n.get({ id: 'Truck.four_px', dm: '卡车' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'Express.four_px', dm: '快递' }),
    value: 'E',
  },
];

export {
  FBA_ORDER_TYPE,
  OPERATION_DESC_TYPE,
  IS_TYPE,
  FROM_WAREHOUSE_MODE,
  SHIPPING_TYPE,
  FBA_IN_ORDER_TYPE,
  FBA_STOCKING_STATE,
  FBA_DELIVER_TYPE,
  FBA_TRAQNSPORT_TYPE,
};
